export default __webpack_public_path__ + "static/media/Interbank Transfer-01.24656f9a.svg";